import { ToggleSize } from './Toggle.types';

export const KNOB_SIZE: Record<ToggleSize, number> = {
  small: 8,
  medium: 16
};
